import DataGridActionHeader from "components/common/controls/grid/DataGridActionHeader";
import UserEditorPopup from "./UserEditorPopup";
import { useState } from "react";
import { EditorMode } from "shared/enums/EditorModeEnum";

export default function ManageUserGridActionHeader() {
  const [isCreateNewUserPopupVisible, setIsCreateNewUserPopupVisible] = useState(false);

  const handleCreateNewUserClick = () => {
    setIsCreateNewUserPopupVisible(true);
  };
  const handleCreateNewUserPopupClose = () => {
    setIsCreateNewUserPopupVisible(false);
  };

  return (
    <>
      <DataGridActionHeader
        displayNew={true}
        newButtonText="Create New User"
        onNewClick={handleCreateNewUserClick}
      />
      {isCreateNewUserPopupVisible && (
        <UserEditorPopup
          onClose={handleCreateNewUserPopupClose}
          mode={EditorMode.Create}
        />
      )}
    </>
  );
};
